import * as React from "react";
import {Col, Form, Input, Row, InputNumber, Switch} from "antd";
import {createRequest, fetchItemRequest, updateRequest} from "../../actions/channel";
import {Channel} from "../../models/channel";
import {FormattedMessage} from "react-intl";
import channelApi from "../../api/channel";
import subscriptionApi from "../../api/subscription";
import withFormWrapper from "../../hocs/withFormWrapper";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  channel?: Channel;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type ChannelFormAllProps = PropsFromState & PropsFromDispatch;

type ChannelFormStateShape = {
  title: string,
  slug: string,
  order: number,
  is_active: true,
  id: string,
};


class ChannelForm extends React.Component<
  ChannelFormAllProps,
  ChannelFormStateShape
> {
  constructor(props) {
    super(props);
    const {channel} = props;
    this.state = {
      visible: false,
      ...this.getStateFromProps(channel)
    };
  }

  getStateFromProps = (channel: Channel | null) => {
    const obj: any = channel || {};
    return {
      id: obj.id,
      title: obj.title,
      slug: obj.slug,
      order: obj.order,
      is_active: obj.is_active,
    };
  };

  fetchItem = () => {
    channelApi
      .getItem({
        params: {
          id: this.state.id
        }
      })
      .then(({data}) => {
        const obj = this.getStateFromProps(data);
        this.setState(obj);
      })
      .catch(error => console.log(error));
  };

  getValues = () => {
    let returnValues = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
        };
      }
    });

    return {
      payload: returnValues,
      id: this.props.channel ? this.props.channel.id : null
    };
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form className={'channel-form'}>
        <Row>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.title" defaultMessage={`Title`}/>}>
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [{
                  required: true,
                  whitespace: true,
                  message: (
                    <FormattedMessage
                      id="app.title_is_required"
                      defaultMessage={`Title is required`}
                    />
                  )
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.slug" defaultMessage={`Slug`}/>}>
              {getFieldDecorator("slug", {
                initialValue: this.state.slug,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.slug_is_required"
                      defaultMessage={`Slug is required`}
                    />
                  )
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.display_order" defaultMessage={`Display Order`}/>}>
              {getFieldDecorator("order", {
                initialValue: this.state.order,
                rules: [{
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.display_order_is_required"
                      defaultMessage={`Order is required`}
                    />
                  )
                }]
              })(<InputNumber min={0}/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Form.Item label={<FormattedMessage id="app.active_channel" defaultMessage={`Active channel`}/>}>
            {getFieldDecorator("is_active", {
              initialValue: this.state.is_active,
            })(<Switch defaultChecked={this.state.is_active}/>)}
          </Form.Item>
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(
  Form.create({name: "channel-form"})(ChannelForm)
);
